export const UNIS_EC_APP_NAME = 'UNIS-EC';
export const UNIS_EC_DEVICE_PORT_PC_APP_NAME = 'NORTEC-700-App';
export const UNIS_UT_WINDVIEW_APP_NAME = 'WindView';
export const UNIS_UT_AEROVIEW_APP_NAME = 'AeroView';
export const UNIS_UT_ONEUTVIEW_APP_NAME = 'OneUtView';
export const SYSTEM_CONTROL_VIEW_APP_NAME = 'system-control-view';
export const UNIS_UT_EPOCH_700_APP_NAME = 'epoch_700';
export const UNIS_UT_UT_LIVE_APP_NAME = 'UT_Live';
export const UNIS_UT_OMNISCAN_700_APP_NAME = 'Omniscan700';
export const UNIS_EC_DESKTOP_APP_NAME = 'EC-DESKTOP';
